
/** The public name of the application  */
export const appName = 'OnlinePlåt';

/** Global variable for identifying what DOM node will mount the SPA interface */
export const appNode = 'app';

/** Global variable for identifying what DOM node will render the current view, exluding static elements */
export const viewNode = 'app-content';

/** Global variable for identifying what DOM node will render the static header content above the view node */
export const headerNode = 'app-header';

/** Global variable for identifying what DOM node will render the static footer content below the view node */
export const footerNode = 'app-footer';

/** Global variable for identifying the base URL path for where the application is accessible */
export const basePath = appNode;

/** Defult server port to run on */
export const basePort = 1337;

/** Server port to run on staging */
export const stagingPort = 1337;

/** Defult server adress to load from on production */
export const productionUrl = 'app.onlineplat.se';

/** Defult server adress to load from on staging */
export const stagingUrl = 'app.onlineplat.se';

/**
 * Creates the HTML that will be rendered for the GUI
 * including an the client properties object
 */
export const html = (
         /** Object of properties to make available to the client */ clientProperties: ClientProperties
       ) => `
<!DOCTYPE html>
<html>
	<head>
		<meta charset="utf-8">
		<title>Onlineplåt</title>
		<meta name="format-detection" content="telephone=no">
		<meta name="viewport" content="viewport-fit=cover, width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no" />
		<meta name="apple-mobile-web-app-capable" content="yes">
		<meta name="apple-mobile-web-app-status-bar-style" content="default">
		<meta name="apple-mobile-web-app-title" content="${appName}">
		<link rel="manifest" href="/static/manifest.json" />
		<link rel="apple-touch-icon" sizes="180x180" href="/static/database/icons/favicons/apple-touch-icon.png">
		<link rel="icon" type="image/png" sizes="32x32" href="/static/database/icons/favicons/favicon-32x32.png">
		<link rel="icon" type="image/png" sizes="16x16" href="/static/database/icons/favicons/favicon-16x16.png">
		<link rel="manifest" href="/static/database/icons/favicons/site.webmanifest">
		<link rel="mask-icon" href="/static/database/icons/favicons/safari-pinned-tab.svg" color="#9013fe">
		<meta name="msapplication-TileColor" content="#da532c">
		<meta name="theme-color" content="#ffffff">

		<link rel="shortcut icon" href="/static/database/icons/favicons/favicon_logo.ico" />
		<!-- Fastclick -->
		<script src="https://cdnjs.cloudflare.com/ajax/libs/fastclick/1.0.6/fastclick.js"></script>
		<script>
			<!-- Fastclick -->
			if ('addEventListener' in document) {
				document.addEventListener('DOMContentLoaded', function() {
					FastClick.attach(document.body);
				}, false);
			}
			<!-- Promise polyfill -->
			if (!window.Promise) {
				document.writeln('<script src="https://cdnjs.cloudflare.com/ajax/libs/es6-promise/4.1.1/es6-promise.min.js"'+'>'+'<'+'/'+'script>');
			}
		</script>
		<style>
			*::-webkit-scrollbar {
				display: none;
			}
		</style>
		<!-- Client properties and global variables -->
		<script>
			var __SERVER__ = false;
			var __DEV__ = ${JSON.stringify(__DEV__)};
			var __PROPS__ = ${JSON.stringify(clientProperties)};
		</script>
		<!-- Keyboard bindings to react native -->
		<script>
			/** Notifies the view content that the keyboard has been opened in the native app */
			function addKeyboard(keyboardHeight) {
				// try {
				// 	keyboardHeight = keyboardHeight || "250";
				// 	var element = document.getElementById('${viewNode}');
				// 	element.style.bottom = keyboardHeight + "px";
				// 	element.classList.add('with-keyboard');
				// }
				// catch (err) {
				// 	console.error(err);
				// }
				// return true;
			}
			/** Notifies the view content that the keyboard has been hidden in the native app */
			function removeKeyboard(keyboardHeight) {
				// try {
				// 	keyboardHeight = keyboardHeight || "0";
				// 	var element = document.getElementById('${viewNode}');
				// 	element.style.bottom = keyboardHeight + "px";
				// 	element.classList.remove('with-keyboard');
				// }
				// catch (err) {
				// 	console.error(err);
				// }
				// return true;
			}
		</script>
	</head>
	<body>
		<div id="${appNode}"></div>
		<script src="/build/vendors.bundle.js"></script>
		<script src="/build/main.bundle.js"></script>
	</body>
</html>`;
